// Một hóa đơn lập được nhiều biên bản cùng loại, mỗi lần độc lập nhau.
// Các hàm dưới đây chọn ra bản đang dở (nháp / ký 1 bên) để modal lập biên bản
// cho xem lại.
import {
  AGREEMENT_PENDING_SIGN_STATUSES,
  AGREEMENT_SIGN_STATUS_TITLE,
} from "constants/AgreementReportConstant";

/** Bản nháp / ký 1 bên của đúng loại biên bản, giữ thứ tự BE trả về */
export const getPendingAgreements = (items, type) =>
  (items || []).filter(
    item =>
      item?.type === type &&
      AGREEMENT_PENDING_SIGN_STATUSES.includes(item?.sign_status)
  );

/** "2026-07-27" -> "20260727": phân biệt các lần lập trong cùng một loại */
export const formatReportDateCompact = reportDate =>
  reportDate ? String(reportDate).slice(0, 10).replace(/-/g, "") : "";

/** "Số biên bản 265 - 20261021" — ghi rõ con số là số biên bản, kèm ngày lập */
export const formatAgreementNumber = item =>
  `Số biên bản ${[
    item?.code || `#${item?.agreement_id}`,
    formatReportDateCompact(item?.report_date),
  ]
    .filter(Boolean)
    .join(" - ")}`;

/** Nhãn một biên bản trong dropdown modal lập biên bản: số biên bản [trạng thái ký] */
export const buildAgreementOptionLabel = item => {
  const statusTitle = AGREEMENT_SIGN_STATUS_TITLE[item?.sign_status];
  return statusTitle
    ? `${formatAgreementNumber(item)} [${statusTitle}]`
    : formatAgreementNumber(item);
};
